import { consume } from '@lit/context';
import { localized } from '@weavedev/lit-i18next';
import { LitElement, css, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';

import { StepDto } from '@/api-sdk';
import {
  ConfiguratorContextType,
  GlobalComponentType,
  MobileContext,
  configuratorGlobal,
  global,
} from '@/context';
import { ANIMATION_SPEED, BREAKPOINT_MEDIUM_PX } from '@/settings';
import { buttonStyles } from '@/styles';

const DEFAULT_SUMMARY_TOP = 16;

/**
 * @element fg-configurator-action-sections
 */
@customElement('fg-configurator-action-sections')
@localized()
export class FgConfiguratorActionSection extends LitElement {
  @property({ type: Number })
  currentStep = 0;

  @property({ type: Array })
  steps: StepDto[] = [];

  @consume({ context: global.context })
  globalContext!: GlobalComponentType;

  @consume({ context: configuratorGlobal.context, subscribe: true })
  configurationContext!: ConfiguratorContextType;

  @consume({ context: MobileContext, subscribe: true })
  isMobile: boolean = false;

  render() {
    const summaryTop = !this.configurationContext.stickySummaryHeight
        ? DEFAULT_SUMMARY_TOP
        : this.configurationContext.stickySummaryHeight + DEFAULT_SUMMARY_TOP,
      { layout } = this.globalContext;

    return html`
      <div
        class="action-sections"
        style=${layout === 'wholesale' && !this.isMobile
          ? styleMap({ top: `${summaryTop}px` })
          : nothing}
      >
        <slot name="mobile-navigation"></slot>
        <section
          class=${`configurator-actions ${
            this.currentStep === this.steps.length ||
            this.globalContext.layout === 'wholesale'
              ? 'show'
              : 'hidden'
          }`}
        >
          <slot name="configurator-actions"></slot>
        </section>
      </div>
    `;
  }

  static styles = [
    buttonStyles,
    css`
      @media screen and (max-width: ${BREAKPOINT_MEDIUM_PX - 1}px) {
        .action-sections {
          position: absolute;
          box-sizing: border-box;
          bottom: 0;
          left: 0;
          background-color: #fff;
          display: flex;
          flex-direction: column;
          column-gap: 16px;
          width: 100%;
          box-shadow: var(--fg-boxshadow, var(--fg-fallback-boxshadow));
        }

        :host([part='wholesale']) .action-sections {
          flex-direction: column-reverse;
        }

        .configurator-actions {
          width: 100%;
          max-height: 0;
          opacity: 0;
          transition:
            max-height ${ANIMATION_SPEED}s ease-in-out,
            opacity ${ANIMATION_SPEED}s ease-in-out;
          height: auto;
        }

        .configurator-actions.show {
          opacity: 1;
          max-height: 100vh;
        }
      }

      @media screen and (min-width: ${BREAKPOINT_MEDIUM_PX}px) {
        :host {
          position: relative;
        }

        .action-sections {
          position: sticky;
        }
      }
    `,
  ];
}
